import React from 'react';
import * as FPT from '../utility/fpt';
import AppStore from '../stores/AppStore';
import TemplateData from '../utility/getTemplateData';

const PAGE_TRACK_TAG = 'main:donate:wps:';

export default function withPageTrack(WrappedComponent, flow, result) {
  return class extends React.Component {
    componentDidMount() {
      const confData = AppStore.getConfirmation() || {};
      const isSignUp = confData.showAccountOverview || false;
      const trid = confData.confirmationNumber || '';

      if (isSignUp || TemplateData.fptPageName === 'guestULSignUp') {
        flow = 'signup';
      }

      let tag = `${PAGE_TRACK_TAG}${flow}:${result}`;
      FPT.trackPage(tag, `${tag}:web::`, 'trid', trid);
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
